// extracted by mini-css-extract-plugin
module.exports = {"withBorder":"CountrySelect_withBorder__351JY","country":"CountrySelect_country__2K60H","resident":"CountrySelect_resident__3rP7r"};